var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.spinner,
    ( _obj = {}, _obj[_vm.$style.spinner_NORMAL] = !_vm.isLarge, _obj ),
    ( _obj$1 = {}, _obj$1[_vm.$style.spinner_LARGE] = _vm.isLarge, _obj$1 )
  ]},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }